import React, { useState, useEffect } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import "../../../../styles/userManagement.css";
// import ViewIssueTable from './viewIssues'
import CreateIssueTable from "./createIssue";
import ViewIssue from "../../AnalystIssueManagement/viewIssues";
import UpdateIssue from "../../AnalystIssueManagement/updateRequests";
import ActionIssue from "../../AnalystIssueManagement/actionRequests";

import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp";

const IssueManagement = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [vendors, setVendors] = useState();
  const [assessment, setAssessment] = useState();
  const [analyst, setAnalyst] = useState();
  const [risk, setRisk] = useState();
  const [viewIssues, setViewIssues] = useState([]);
  const [viewUpdateRequests, setViewUpdateRequests] = useState([]);
  const [viewActionRequests, setViewActionRequests] = useState([]);
  const [priorityList, setPriorityList] = useState();
  const { sendRequest: getAllAssessmentVendorList } = useHttp();
  const { sendRequest: getViewActionRequestsAPI } = useHttp();
  const { sendRequest: getViewUpdateRequestsAPI } = useHttp();
  const { sendRequest: getAllViewIssuesAPI } = useHttp();
  const { sendRequest: getAllAnalystDataAPI } = useHttp();
  const { sendRequest: getAssessmentDataAPI } = useHttp();
  const { sendRequest: getAllPriorityLevels } = useHttp();
  const { sendRequest: getManageRiskData } = useHttp();

  const handleTabs = (v) => {
    setCurrentTab(v);
  };
  const getAllViewIssuesData = async () => {
    await getAllViewIssuesAPI(
      APIService.getAllViewIssues(),
      (data) => {
        data.MSG.forEach(function (a) {
          a.created_date = a.created_date.substring(0, 10);
          a.issuedue_date = a.issuedue_date.substring(0, 10);
        });
        setViewIssues(data.MSG);
      }
    );
  };
  const getAllPriorityList = async () => {
    getAllPriorityLevels(APIService.getAllPriorityLevels(), (data) => {
      setPriorityList(data.MSG);
    })
  };
  const getViewUpdateRequest = async () => {
    await getViewUpdateRequestsAPI(
      APIService.getViewUpdateRequests(),
      (data) => {
        data.MSG.forEach(function (a) {
          a.created_date = a.created_date.substring(0, 10);
          a.issuedue_date = a.issuedue_date.substring(0, 10);
        });
        setViewUpdateRequests(data.MSG);
      }
    );
  };
  const getViewActionRequest = async () => {
    await getViewActionRequestsAPI(
      APIService.getViewActionRequests(),
      (data) => {
        data.MSG.forEach(function (a) {
          a.created_date = a.created_date.substring(0, 10);
          a.issuedue_date = a.issuedue_date.substring(0, 10);
        });
        setViewActionRequests(data.MSG);
      }
    );
  };
  const getAllVendorListData = async () => {
    getAllAssessmentVendorList(
      APIService.getAllAssessmentVendorList(),
      (data) => {
        setVendors(data.MSG);
      }
    );
  };
  const getAssessmentDetails = async () => {
    await getAssessmentDataAPI(APIService.getAssessmentData(), (data) =>
      setAssessment(data.MSG)
    );
  };
  const getRiskData = async () => {
    getManageRiskData(APIService.getManageRiskData(), (data) => {
      setRisk(data.MSG);
    })
  };
  const getAllAnalyst = async () => {
    await getAllAnalystDataAPI(APIService.getAllAnalystData(), (data) =>
      setAnalyst(data.MSG)
    );
  };

  const handleBack = () => {
    setCurrentTab(0);
  };
  useEffect(() => {
    getAllVendorListData();
    getAssessmentDetails();
    getRiskData();
    getAllAnalyst();
    getAllViewIssuesData();
    getViewUpdateRequest();
    getViewActionRequest();
    getAllPriorityList();
  }, []);
  return (
    <div className="user-management-container">
      <Tabs
        activeIndex={currentTab}
        onTabChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="view-issues" label="View Issues">
          <ViewIssue
            viewIssues={viewIssues}
            reload={getAllViewIssuesData}
            vendors={vendors}
            assessment={assessment}
            risk={risk}
            analyst={analyst}
            priorityList={priorityList}
          />
        </Tab>
        <Tab value="view-update-requests" label="View Update Requests">
          <UpdateIssue
            viewIssues={viewUpdateRequests}
            vendors={vendors}
            reload={getViewUpdateRequest}
            assessment={assessment}
            risk={risk}
            analyst={analyst}
            priorityList={priorityList}
          />
        </Tab>
        <Tab value="view-action-requests" label="View Action Requests">
          <ActionIssue
            viewIssues={viewActionRequests}
            vendors={vendors}
            reload={getViewActionRequest}
            reloadIssues={getAllViewIssuesData}
            assessment={assessment}
            risk={risk}
            analyst={analyst}
            priorityList={priorityList}
          />
        </Tab>
        <Tab value="create-issue" label="Create Issue">
          <CreateIssueTable
            vendors={vendors}
            assessment={assessment}
            risk={risk}
            analyst={analyst}
            reload={getAllViewIssuesData}
            handleBack={handleBack}
            priorityList={priorityList}
            SetTab={setCurrentTab}
          />
        </Tab>
      </Tabs>
    </div>
  );
};

export default IssueManagement;
